import { AlertInfoState, AlertTypeEnum, EventCoordinates } from '../alert.state';

export class AlertReduxState {
  alertStates: AlertState[];

  constructor() {
    this.alertStates = [];
  }

  static getIdOrDefault(id?: number): number {
    return id || this.getRandomInt(1000000);
  }

  private static getRandomInt(max) {
    return Math.floor(Math.random() * Math.floor(max));
  }

  static getTimeoutOrDefault(timeout: number, type: AlertTypeEnum) {
    if (timeout !== null && timeout !== undefined) return timeout;
    if (type === AlertTypeEnum.Info) {
      return 10_000;
    } else {
      return 0;
    }
  }

  addInfo(alertInfo: AlertInfo) {
    let alertState: AlertState;
    const placeholder: PlaceholderEnum =
      alertInfo.placeholder !== null && alertInfo.placeholder !== undefined
        ? alertInfo.placeholder
        : PlaceholderEnum.Default;
    if (placeholder === PlaceholderEnum.Default && this.alertStates && this.alertStates.length > 0) {
      alertState = this.alertStates[this.alertStates.length - 1];
    } else {
      alertState = this.alertStates.find(as => as.placeholder === placeholder);
    }
    if (!alertState) {
      alertState = new AlertState(placeholder);
      this.alertStates.push(alertState);
    }

    const alertInfoState: AlertInfoState = {
      type: alertInfo.type,
      text: alertInfo.text,
      timeout: AlertReduxState.getTimeoutOrDefault(alertInfo.timeout, alertInfo.type),
      id: AlertReduxState.getIdOrDefault(alertInfo.id),
      canClose: false, // TODO: does not work right now
      eventCoordinates: alertInfo.eventCoordinates,
    };
    alertState.alerts.push(alertInfoState);
  }

  addPlaceholder(placeholder: PlaceholderEnum) {
    let alertState: AlertState = this.alertStates.find((as: AlertState) => as.placeholder === placeholder);
    if (!alertState) {
      alertState = new AlertState(placeholder);
      this.alertStates.push(alertState);
    }

    // Move alerts from default placeholder to top one
    const defaultAlertStateIdx: number = this.alertStates.findIndex(
      (as: AlertState) => as.placeholder === PlaceholderEnum.Default
    );
    if (defaultAlertStateIdx >= 0) {
      const defaultAlertState: AlertState = this.alertStates[defaultAlertStateIdx];
      this.alertStates.splice(defaultAlertStateIdx, 1);
      defaultAlertState.alerts.forEach(alert => this.addInfo(alert));
    }
  }

  removePlaceholder(placeholder: PlaceholderEnum) {
    const idx: number = this.alertStates.findIndex((as: AlertState) => as.placeholder === placeholder);
    if (idx >= 0) this.alertStates.splice(idx, 1);
  }

  remove(alertId: number) {
    for (const alertState of this.alertStates) {
      const idx: number = alertState.alerts.findIndex((as: AlertInfoState) => as.id === alertId);
      if (idx >= 0) alertState.alerts.splice(idx, 1);
    }
  }

  clear(placeholder: PlaceholderEnum) {
    const alertState: AlertState = this.alertStates.find((as: AlertState) => as.placeholder === placeholder);
    if (alertState) alertState.alerts.splice(0);
  }

  getRecords(placeholder: PlaceholderEnum): AlertInfoState[] {
    return this.alertStates.find((as: AlertState) => as.placeholder === placeholder).alerts;
  }
}

export class AlertState {
  placeholder: PlaceholderEnum;
  alerts: AlertInfoState[];

  constructor(placeholder: PlaceholderEnum) {
    this.placeholder = placeholder;
    this.alerts = [];
  }
}

export enum PlaceholderEnum {
  Default = 0,
  MainPage = 1,
  ModalWindow = 2,
}

export class AlertInfo {
  type: AlertTypeEnum;
  text: string;
  timeout?: number; // 0 or less - never hide. null - default
  id?: number;
  placeholder?: PlaceholderEnum;
  eventCoordinates?: EventCoordinates;
}
